import React, { Fragment } from "react";

import { useNavigate } from "react-router-dom";

import {
  NoDataFound,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "../../../../../../components/table/tableComponent";
import Loading from "../../../../../../components/skeleton/loading";
import { TableHeader } from "../../../../../../components/table/tableComponent";
import DefaultAvatar from "../../../../../../components/avatar/defaultAvatar";
import DefaultInput from "../../../../../../components/inputs/defaultInput";
import pic from "../../../../../../assets/images/profile-sample.jpg";
import DefaultBadge from "../../../../../../components/badge/defaultBadge";
import DefaultButton from "../../../../../../components/buttons/defaultButton";
import { IoMdClose } from "react-icons/io";
import { IoCheckmark } from "react-icons/io5";
import ConfirmModal from "../../../../../../components/modals/ConfirmModel";
import { PiDownloadSimple } from "react-icons/pi";
const SalaryReportTable = ({
  tableData = [],
  handleStatus,
  onConfirm,
  isOpen,
  setIsOpen,
  loading,
  toggleModal,
  handleUpdateForAll,
  handleUpdateForMakeSalary,
  setIsConfirmOpen,
  downloadPaySlip,
  downloadLoading,
}) => {
  const navigate = useNavigate();

  const customCases = {
    0: "Pending",
    1: "Paid",
  };

  const headers = [
    "Employee Name",
    "Salary date",
    "Calculated salary",
    "Adjustment amount",
    "Net Salary",
    "Adjustments",
    "Action",
  ];

  return (
    <div className="flex flex-col gap-2">
      {loading ? (
        <Loading />
      ) : (
        <Fragment>
          <Table className="shadow-md overflow-x-auto">
            <TableHeader>
              <TableRow>
                <TableHead>
                  <div
                    className="flex items-center gap-2 cursor-pointer"
                    onClick={() => {
                      if (!loading && tableData?.length) {
                        handleUpdateForAll();
                      }
                    }}
                  >
                    <span
                      className={`rounded-md min-w-6 w-6 min-h-6 h-6 flex items-center justify-center border `}
                    >
                      <span
                        className={`w-4 h-4 rounded-sm ${
                          tableData &&
                          !!tableData.length &&
                          tableData.every((data) => data.forPaid)
                            ? "bg-success-500 text-white"
                            : "bg-white"
                        }`}
                      ></span>
                    </span>
                    <span>Select All</span>
                  </div>
                </TableHead>
                {headers.map((header, index) => (
                  <TableHead
                    className={`min-w-[150px] ${
                      index === 0
                        ? "sticky left-0 bg-light z-10" // sticky for first column
                        : ""
                    } ${index === headers.length - 1 ? "bg-light" : ""}`}
                    key={index}
                  >
                    <span className="flex justify-between items-center">
                      {header}
                    </span>
                  </TableHead>
                ))}
              </TableRow>
            </TableHeader>

            <TableBody>
              {tableData && tableData.length > 0 ? (
                tableData.map((data, index) => (
                  <TableRow key={index}>
                    <TableCell
                      className="sticky left-0 bg-white z-10 cursor-pointer"
                      onClick={() => {
                        if (data.status != 1) {
                          if (!data.is_paid) {
                            handleUpdateForMakeSalary(data.id);
                          }
                        }
                      }}
                    >
                      <span
                        className={`rounded-md min-w-6 w-6 min-h-6 h-6 flex items-center justify-center border`}
                      >
                        <span
                          className={`w-4 h-4 rounded-sm  ${
                            data.status === 1
                              ? "bg-gray-300"
                              : data.forPaid
                              ? "bg-success-500"
                              : ""
                          }`}
                        />
                      </span>
                    </TableCell>

                    <TableCell className="sticky left-0 bg-white z-10">
                      <span className="flex flex-row gap-1 items-center">
                        <DefaultAvatar image={pic} />
                        {data?.user?.name}
                      </span>
                    </TableCell>

                    <TableCell> {data?.salary_date}</TableCell>
                    <TableCell> {data?.calculated_salary}</TableCell>
                    <TableCell> {data?.adjustment_amount}</TableCell>
                    <TableCell> {data?.final_amount}</TableCell>
                    <TableCell>
                      <DefaultBadge
                        status={data?.status}
                        customCases={customCases}
                      />{" "}
                    </TableCell>
                    <TableCell className="flex flex-row gap-2">
                      {/* Approved Rejected */}
                      {data.status != 1 ? (
                        <>
                          <DefaultButton
                            className="text-textLight"
                            onClick={() => toggleModal(data)}
                            name={<IoCheckmark />}
                            variant="iconButton"
                            classnames="text-error-500"
                            disabled={data.status === 1}
                          />
                          <DefaultButton
                            onClick={() =>
                              handleStatus(data.uuid, index, "rejected")
                            }
                            name={<IoMdClose />}
                            variant="iconButton"
                            classnames="text-error-500"
                            disabled={data.status === 1}
                          />
                        </>
                      ) : (
                        <DefaultButton
                          disabled={downloadLoading || data.status !== 1}
                          tooltip="Download"
                          variant="secondary"
                          icon={<PiDownloadSimple />}
                          onClick={() => downloadPaySlip(data.uuid)}
                        />
                      )}
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <NoDataFound colSpan={headers.length} text="No Report Found." />
              )}
            </TableBody>
          </Table>
        </Fragment>
      )}
      <ConfirmModal
        isOpen={isOpen}
        title="Are you sure?"
        message="Do you want Reject Salary Please confirm."
        onConfirm={onConfirm}
        onCancel={() => setIsOpen(false)}
      />
    </div>
  );
};

export default SalaryReportTable;
